module.exports = __webpack_public_path__ + "static/img/avatar@3x.69d10bc0.png";